import { ApolloClient, from } from '@apollo/client'
// import createPersistedQueryLink from './create-persisted-query-link'
import { createErrorLink } from './create-error-link'
import { createContextLink } from './create-context-link'
import { createHttpLink } from './create-http-link'
import { createCache } from './create-cache'
import { isTestEnv } from '../utils/is-test-env'

export const createApolloClient = () => {
  const baseLinks = [createErrorLink(), createContextLink(), createHttpLink()]
  return new ApolloClient({
    cache: createCache(),
    link: from(
      isTestEnv()
        ? baseLinks
        : [
            /* TODO: persisted queries is not sending follow-up request in production only - createPersistedQueryLink(), */ ...baseLinks,
          ]
    ), // Persisted Queries won't work in tests, so we need to exclude that link
  })
}
